import { render, staticRenderFns } from "./step7improving_ecology.vue?vue&type=template&id=353fbff0&scoped=true"
import script from "./step7improving_ecology.vue?vue&type=script&lang=js"
export * from "./step7improving_ecology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353fbff0",
  null
  
)

export default component.exports